/**
 * @generated SignedSource<<1c0c89d79fe77d1b063869de36dc5dd5>>
 * @relayHash 29bcc67d3111f4f97c3c431cc81c9399
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e6bb19ae6a019c7084d957bb2ca18f4a8866b288d1764e44f293dc9cd1f7ff53

import type { ConcreteRequest } from 'relay-runtime';
export type usePageIncludeMacroQueryByIdQuery$variables = {
  contentId: string;
};
export type usePageIncludeMacroQueryByIdQuery$data = {
  readonly singleContent: {
    readonly body: {
      readonly atlas_doc_format: {
        readonly mediaToken: {
          readonly token: string | null;
        } | null;
        readonly value: string | null;
      } | null;
    } | null;
    readonly id: string | null;
    readonly space: {
      readonly id: string | null;
      readonly key: string | null;
    } | null;
    readonly title: string | null;
    readonly type: string | null;
  } | null;
};
export type usePageIncludeMacroQueryByIdQuery = {
  response: usePageIncludeMacroQueryByIdQuery$data;
  variables: usePageIncludeMacroQueryByIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      }
    ],
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "singleContent",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "kind": "ScalarField",
        "name": "title"
      },
      {
        "kind": "ScalarField",
        "name": "type"
      },
      {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "key"
          },
          (v1/*: any*/)
        ]
      },
      {
        "concreteType": "ContentBodyPerRepresentation",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": [
          {
            "concreteType": "ContentBody",
            "kind": "LinkedField",
            "name": "atlas_doc_format",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "value"
              },
              {
                "concreteType": "EmbeddedMediaToken",
                "kind": "LinkedField",
                "name": "mediaToken",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "token"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "usePageIncludeMacroQueryByIdQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "usePageIncludeMacroQueryByIdQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "29bcc67d3111f4f97c3c431cc81c9399",
    "id": "e6bb19ae6a019c7084d957bb2ca18f4a8866b288d1764e44f293dc9cd1f7ff53",
    "metadata": {},
    "name": "usePageIncludeMacroQueryByIdQuery",
    "operationKind": "query",
    "text": "query usePageIncludeMacroQueryByIdQuery($contentId:ID!){singleContent(id:$contentId){id,title,type,space{key,id},body{atlas_doc_format{value,mediaToken{token}}}}}"
  }
};
})();

(node as any).hash = "983fd7d5b2c3bedd36acf332a4d2a21e";

export default node;
